import api from '../../../services/api'
import type { BruktbilFilters } from '../useBruktbilFilters'

export interface MerkeChip {
  merke: string
  count: number
}

export interface KjoperRow {
  org_nr: string | null
  org_name: string | null
  /** The org's registered business address, not the transfer's (#594 AC1). */
  postnummer: string | null
  count: number
  avg_bilalder: number | null
  top_merker: MerkeChip[]
  drivstoff_dominant: string | null
  drivstoff_share: number | null
}

export interface KjoperResponse {
  data: KjoperRow[]
  total: number
  page: number
  pages: number
}

export interface FirmaResponse {
  rows: KjoperRow[]
  total: number
}

export interface PersonVsOrgResponse {
  person_count: number
  org_count: number
  person_share: number
  org_share: number
  total: number
}

type BaseParams = Pick<BruktbilFilters, 'from' | 'to' | 'klasse' | 'varebil' | 'omregistrering'> & {
  selgerPostnummer?: string | null
  kjoperPostnummer?: string | null
  classification?: string | null // buyer org classification filter (#475)
}

function baseParams(f: BaseParams) {
  return {
    from_date: f.from,
    to_date: f.to,
    klasse: f.klasse,
    varebil: f.varebil,
    omregistrering: f.omregistrering || undefined,
    classification: f.classification || undefined,
    ...(f.selgerPostnummer ? { selger_postnummer: f.selgerPostnummer.split(',') } : {}),
    ...(f.kjoperPostnummer ? { kjoper_postnummer: f.kjoperPostnummer.split(',') } : {}),
  }
}

export function fetchKjopere(
  filters: BaseParams,
  page = 1,
): Promise<{ data: KjoperResponse }> {
  return api.get<KjoperResponse>('/bruktbil/kjopere', {
    params: { ...baseParams(filters), page, page_size: 50 },
    paramsSerializer: { indexes: null },
  })
}

export function fetchKjopereFirma(
  filters: BaseParams,
  limit = 50,
  offset = 0,
): Promise<{ data: FirmaResponse }> {
  return api.get<FirmaResponse>('/bruktbil/kjopere/firma', {
    params: { ...baseParams(filters), limit, offset },
    paramsSerializer: { indexes: null },
  })
}

export function fetchPersonVsOrg(
  filters: BaseParams,
): Promise<{ data: PersonVsOrgResponse }> {
  return api.get<PersonVsOrgResponse>('/bruktbil/kjopere/person-vs-org', {
    params: baseParams(filters),
  })
}
